module.exports = __webpack_public_path__ + "static/media/mapel.08f09840.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mapel.png
// module id = 1610
// module chunks = 0